import { openai } from '@ai-sdk/openai';
import { customProvider } from "ai";

const languageModels = {
  "gpt-4o": openai("gpt-4o"),
  "gpt-4o-tubo": openai("gpt-4o-tubo"),
};

export const model = customProvider({
  languageModels,
});

export type modelID = keyof typeof languageModels;

export const MODELS = Object.keys(languageModels);

export const defaultModel: modelID = "gpt-4o";
